import * as t from 'io-ts'

export const ConceptCodec = t.type({
    conceptId: t.string,
    conceptLabel: t.string,
    conceptType: t.string,
})

export type Concept = t.TypeOf<typeof ConceptCodec>
